import * as React from 'react';
import { Form, Input, Button, Select, Divider, message, Spin, Checkbox, Tooltip } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import { RouteComponentProps, withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import ResetPasswordDTO from 'src/models/account/ResetPasswordDTO';
import UserApiController from 'src/api/UserApiController';
import USResetPasswordForm from './USResetPasswordForm';

export interface ResetPasswordStateParams {
    previousLocation?: string;
    previousState?: {};
}

interface RouteParams {
    userId: string;
}

interface USResetPasswordProps extends PageProps<RouteParams, ResetPasswordStateParams>, LocalizeContextProps { }

interface USResetPasswordState {
    isSubmitting: boolean;
    currentResetPassword: ResetPasswordDTO;
}

class USResetPassword extends React.Component<USResetPasswordProps, USResetPasswordState> {
    constructor(props: USResetPasswordProps) {
        super(props);
        bindAllOfThis(this, USResetPassword.prototype);

        let userId = parseInt(this.props.match.params.userId, 10);

        this.state = {
            isSubmitting: false,
            currentResetPassword: {
                userId: userId,
                newPassword: "",
                confirmPassword: ""
            } as ResetPasswordDTO
        };
    }

    private handleRedirect(): void {
        // We rely on the state parameter to know where to go back to. If not provided, go home
        let state = this.props.location.state;
        let nextLocation = state != null && state.previousLocation != null ? state.previousLocation : Routes.BASE_ROUTE;
        this.props.history.push(nextLocation, state.previousState);
    }

    private handleSubmit(values: ResetPasswordDTO) {
        this.setState({ isSubmitting: true });

        return UserApiController.adminPasswordReset(values).then(result => {
            message.success(<Translate id="account.resetPassword.messageReset" />);
            this.setState({ isSubmitting: false });
            this.handleRedirect();
        }).catch(e => {
            message.error(<Translate id="account.resetPassword.messageResetError" />);
            this.setState({ isSubmitting: false });
        });
    }

    render() {
        return (
            <div>
                <h2>
                    <Translate id="account.resetPassword.header" />
                </h2>

                <USResetPasswordForm
                    isSubmitting={this.state.isSubmitting}
                    passwordData={this.state.currentResetPassword}
                    onCancel={this.handleRedirect}
                    onSubmit={this.handleSubmit}
                />
            </div >
        );
    }
}

export default withLocalize(USResetPassword as any) as any;



// WEBPACK FOOTER //
// ./src/pages/admin/universalSearch/USResetPassword.tsx